import * as React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { StepIcon } from '../StepIcon';
import { Typography } from '../../Typography';
import { Link } from '../../Link';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
            lineHeight: 0,
        },
        icon: {
            marginRight: '8px',
        },
        button: {
            lineHeight: 0,
            '&[disabled]': {
                color: theme.palette.primary.main,
            },
            '$error &[disabled]': {
                color: theme.palette.error.main,
            },
        },
        stepNumber: {
            fontWeight: theme.typography.fontWeightBold,
        },
        error: {},
    });
});
export var StepLabel = React.forwardRef(function (props, ref) {
    var _a;
    var active = props.active, activeLabel = props.activeLabel, completed = props.completed, completedLabel = props.completedLabel, disabled = props.disabled, error = props.error, errorLabel = props.errorLabel, iconId = props.iconId, inCompleteLabel = props.inCompleteLabel, onClick = props.onClick, stepDescription = props.stepDescription, stepNumber = props.stepNumber;
    var ariaCurrent = active ? 'step' : undefined;
    var ariaExpanded = !!active;
    var classes = useStyles(props);
    return (React.createElement("div", { ref: ref, className: clsx(classes.root, (_a = {}, _a[classes.error] = error, _a)), "data-testid": "step-label" },
        React.createElement(StepIcon, { classes: { root: classes.icon }, active: active, activeLabel: activeLabel, completed: completed, completedLabel: completedLabel, error: error, errorLabel: errorLabel, iconId: iconId, incompleteLabel: inCompleteLabel }),
        React.createElement(Link, { classes: { root: classes.button }, component: "button", color: error ? 'error' : 'secondary', disabled: disabled, onClick: onClick, "aria-current": ariaCurrent, "aria-expanded": ariaExpanded, "aria-describedby": iconId },
            React.createElement(Typography, { component: "span", variant: "body2", className: classes.stepNumber }, stepNumber),
            React.createElement(Typography, { component: "span", variant: "body2" }, stepDescription))));
});
export default StepLabel;
//# sourceMappingURL=StepLabel.js.map